// extracted by mini-css-extract-plugin
module.exports = {"order-list":"OrderList_order-list__2D-Iy","empty":"OrderList_empty__8JG01"};